import React, { useMemo } from 'react';

import { parseNestedAdfDocument } from '@confluence/macro-utils/entry-points/nestedAdfRenderer.ts';

import { PageIncludeContextProvider } from '../contexts/PageIncludeContext.tsx';
import type { PageIncludeRendererWrapperProps, ResolvedTarget } from '../pageIncludeMacroTypes.ts';

export type PageIncludeContentProps = {
	resolvedTarget: ResolvedTarget;
	adfString: string;
	mediaToken?: string;
	RendererWrapper: React.ComponentType<PageIncludeRendererWrapperProps>;
};

export const PageIncludeContent = ({
	resolvedTarget,
	adfString,
	mediaToken,
	RendererWrapper,
}: PageIncludeContentProps): React.JSX.Element => {
	const adfDocument = useMemo(() => parseNestedAdfDocument(adfString), [adfString]);

	return (
		<PageIncludeContextProvider contentId={resolvedTarget.contentId} title={resolvedTarget.title}>
			<RendererWrapper
				adf={adfDocument.content}
				targetContentId={resolvedTarget.contentId}
				targetSpaceKey={resolvedTarget.spaceKey}
				targetSpaceId={resolvedTarget.spaceId}
				mediaToken={mediaToken}
			/>
		</PageIncludeContextProvider>
	);
};
